// extracted by mini-css-extract-plugin
module.exports = {"article":"InsuranceDetailButton_article__WQy_U","inner":"InsuranceDetailButton_inner__wvtYv"};